<template>
  <success-box :title="title">
  </success-box>
</template>
<script>
import SuccessBox from '@/components/commons/SuccessBox.vue';

export default {
  name: 'ChangeExpiredPasswordSuccessful',
  components: {
    SuccessBox,
  },
  data() {
    return {
      title: this.$t('title.changePasswordSuccessful'),
    };
  },
};
</script>
